import * as React from 'react';
import { useGetItilCategoriesService } from '../../hooks/abertura-chamado/abertura-chamado';
import FormChamado from './form-chamado';

const InitialSession = ({ tokenUserGLPI, tokenAppGLPI, glpiUrl }) => {
  const [token, setToken] = React.useState(false);
  const { itilCategories } = useGetItilCategoriesService(
    tokenUserGLPI,
    tokenAppGLPI,
    glpiUrl,
  );

  React.useEffect(() => {
    if (!!itilCategories && !!Object.keys(itilCategories).length) {
      setToken(true);
    }
  }, [itilCategories]);

  return (
    <>
      {token && <FormChamado sessionToken={itilCategories} glpiUrl={glpiUrl} />}
    </>
  );
};

export { InitialSession as default };
